import React, { useMemo } from 'react';
import {
	Table,
	TableBody,
	TableCell,
	TableHeader,
	TableHeaderCell,
	TableRow
} from 'semantic-ui-react';

const formatCurrency = value => `$${ Number( parseFloat( value ).toFixed( 2 ) ).toLocaleString( undefined, {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
} ) }`;

const PlanSummary = ( {
	currentPlan,
	pastPlan,
	year
} ) => {
	const eE_Change = useMemo( () => currentPlan.eE_Premium - pastPlan.eE_Premium, [ currentPlan.eE_Premium, pastPlan.eE_Premium ] );
	const eS_Change = useMemo( () => currentPlan.eS_Premium - pastPlan.eS_Premium, [ currentPlan.eS_Premium, pastPlan.eS_Premium ] );
	const eC_Change = useMemo( () => currentPlan.eC_Premium - pastPlan.eC_Premium, [ currentPlan.eC_Premium, pastPlan.eC_Premium ] );
	const eF_Change = useMemo( () => currentPlan.eF_Premium - pastPlan.eF_Premium, [ currentPlan.eF_Premium, pastPlan.eF_Premium ] );

	return (
		<Table celled>
			<TableHeader>
				<TableRow>
					<TableHeaderCell colSpan={ 5 }>
						{ currentPlan.planName }
					</TableHeaderCell>
				</TableRow>
				<TableRow>
					<TableHeaderCell style={{ width: '200px' }}></TableHeaderCell>
					<TableHeaderCell width={ 4 }>EE</TableHeaderCell>
					<TableHeaderCell width={ 4 }>ES</TableHeaderCell>
					<TableHeaderCell width={ 4 }>EC</TableHeaderCell>
					<TableHeaderCell width={ 4 }>FAM</TableHeaderCell>
				</TableRow>
			</TableHeader>
			<TableBody>
				<TableRow>
					<TableCell>{ year - 1 }&nbsp;Current</TableCell>
					<TableCell>{ formatCurrency( pastPlan.eE_Premium ) }</TableCell>
					<TableCell>{ formatCurrency( pastPlan.eS_Premium ) }</TableCell>
					<TableCell>{ formatCurrency( pastPlan.eC_Premium ) }</TableCell>
					<TableCell>{ formatCurrency( pastPlan.eF_Premium ) }</TableCell>
				</TableRow>
				<TableRow>
					<TableCell>{ year }&nbsp;Renewal</TableCell>
					<TableCell>{ formatCurrency( currentPlan.eE_Premium ) }</TableCell>
					<TableCell>{ formatCurrency( currentPlan.eS_Premium ) }</TableCell>
					<TableCell>{ formatCurrency( currentPlan.eC_Premium ) }</TableCell>
					<TableCell>{ formatCurrency( currentPlan.eF_Premium ) }</TableCell>
				</TableRow>

				<TableRow>
					<TableCell>Change</TableCell>
					<TableCell style={{ color: eE_Change < 0 ? 'red' : 'green' }}>{ formatCurrency( eE_Change ) }</TableCell>
					<TableCell style={{ color: eS_Change < 0 ? 'red' : 'green' }}>{ formatCurrency( eS_Change ) }</TableCell>
					<TableCell style={{ color: eC_Change < 0 ? 'red' : 'green' }}>{ formatCurrency( eC_Change ) }</TableCell>
					<TableCell style={{ color: eF_Change < 0 ? 'red' : 'green' }}>{ formatCurrency( eF_Change ) }</TableCell>
				</TableRow>
			</TableBody>
		</Table>
	);
};

export default PlanSummary;
